import React, { useRef, useState } from "react";
import { Form, Button, Card, Alert, Container, Row, Image } from 'react-bootstrap'
import { useAuth } from '../contexts/AuthContext'
import { Link } from 'react-router-dom'


function ForgotPassword() {

    const emailRef = useRef()
    const { resetPassword } = useAuth()
    const [error, setError] = useState("")
    const [message, setMessage] = useState("")
    const [loading, setLoading] = useState(false)

    async function handleSubmit(e) {
        e.preventDefault()


        try {
            setMessage("")
            setError("")
            setLoading(true)
            await resetPassword(emailRef.current.value)
            setMessage('Check your inbox for password reset instructions')
        } catch {
            setError("Failed to reset password")
        }
        setLoading(false)

    }




    return (
        <>
            <Container>
                <Row className="justify-content-center">
                    <Card className="w-100 mt-4" style={{ maxWidth: "400px" }}>
                        <Card.Body>
                            <h2 className="text-center mb-4">Password Reset</h2>
                            <Image style={{ maxWidth: "80px", height: "auto" }} className="auth-logo" src="/proion-logo.png" />
                            {error && <Alert variant="danger">{error}</Alert>}
                            {message && <Alert variant="success">{message}</Alert>}
                            <Form onSubmit={handleSubmit}>
                                <Form.Group id="email">
                                    <Form.Label>Email</Form.Label>
                                    <Form.Control type="email" ref={emailRef} required></Form.Control>
                                </Form.Group>
                                <Button disabled={loading} className="w-100 login-btn" type="submit">Reset Password</Button>
                            </Form>

                            <div className="w-100 text-center mt-3">
                                <Link to="/login">Log In</Link>
                            </div>

                        </Card.Body>
                    </Card>
                    <div className="w-100 text-center mt-2">
                        Need an account? <Link className="auth-link" to="/signup">Sign up</Link>
                    </div>
                </Row>
            </Container>

        </>
    )
}

export default ForgotPassword